import * as types from './mutation-types'

export default {
    [types.ADD_TIMEZONES]: (state, data) => {
        state.timezones = data
    },

    [types.ADD_OPENING_DAYS]: (state, data) => {
        state.openingDays = data
    }    
}
